"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthenticationContext = void 0;
var react_1 = require("react");
var AuthenticationContext_1 = require("../contexts/AuthenticationContext");
//This custom hook is responsible for consuming the authentication context.
function useAuthenticationContext() {
    var context = (0, react_1.useContext)(AuthenticationContext_1.AuthenticationContext);
    if (!context) {
        throw new Error('The useAuthenticationContext must be used within an AuthenticationProvider.');
    }
    return context;
}
exports.useAuthenticationContext = useAuthenticationContext;
//# sourceMappingURL=useAuthenticationContext.js.map